import { lazy } from "react";

export const LazyCards = lazy(async () => await import("@/pages/shared/cards"));
